import { render } from "./HeroEvent.vue?vue&type=template&id=472ce7e1&scoped=true&ts=true"
import script from "./HeroEvent.vue?vue&type=script&lang=ts"
export * from "./HeroEvent.vue?vue&type=script&lang=ts"

import "./HeroEvent.vue?vue&type=style&index=0&id=472ce7e1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472ce7e1"]])

export default __exports__